// extracted by mini-css-extract-plugin
export default {"checkmark":"SubmitPage_checkmark__l0GQI","formh1":"SubmitPage_formh1__DEOPI","formh2":"SubmitPage_formh2__J7fQw"};